module.exports = __webpack_public_path__ + "static/media/jan 2022.e72a7078.svg";